import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { MspDattoCreds } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspDattoCreds';

export interface State extends Status {
    data: MspDattoCreds | null;
    connected: boolean;
}

export const initialState: State = {
    data: null,
    connected: false,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.loadMspDattoCreds, (state) => ({ ...state, loading: true })),
    on(actions.loadMspDattoCredsSuccess, (state, { data, connected }) => ({
        ...state,
        data,
        connected,
        loaded: true,
        loading: false,
    })),
    on(actions.loadMspDattoCredsFailure, (state, { error }) => ({ ...state, error, loading: false })),

    on(actions.createMspDattoCredsSuccess, (state, { data }) => ({
        ...state,
        data,
        connected: true,
        error: null,
        loaded: true,
    })),
    on(actions.putMspDattoCredsSuccess, (state, { data }) => ({
        ...state,
        data,
        connected: true,
        error: null,
        loaded: true,
    })),

    on(actions.deleteMspDattoIntegrationSuccess, () => initialState),
);

export const selectDataAndConnection = (state: State) => ({ data: state.data, connected: state.connected });
